module.exports = __webpack_public_path__ + "static/media/26UNRWA7.e98e5937.jpg";